import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import BlogCard from '../../componants/blogCard/BlogCard'
import { mapBlogItem } from '../../componants/blogCard/blogPosts'
import service from '../../services/service'
import endpoints from '../../services/endpoints'

const LATEST_COUNT = 3

const OurLatestBlog = () => {
    const navigate = useNavigate()
    const [blogs, setBlogs] = useState([])
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)

    useEffect(() => {
        service
            .get(endpoints.blogs.list, { page: 1, page_size: LATEST_COUNT }, { silent: true })
            .then(({ data }) => {
                const results = data?.data || []
                // Latest blogs first
                const sorted = [...results].sort(
                    (a, b) => new Date(b.published_at || b.created_at) - new Date(a.published_at || a.created_at)
                )
                setBlogs(sorted.map(mapBlogItem))
            })
            .catch(() => {
                setBlogs([])
            })
    }, [])

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <>
            <section className='ourLatestBlog popularDestination paddingCmn'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='secHeadArea'>
                                <div className='mainHead'>Our Latest Insights</div>
                                <Link to="/blog-listing">View All</Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="carousel">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    loop
                                    autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                                    breakpoints={{
                                        576: { slidesPerView: 1 },
                                        768: { slidesPerView: 2 },
                                        992: { slidesPerView: 3 },
                                        1200: { slidesPerView: 3 },
                                    }}
                                >
                                    {blogs.map((blog, index) => (
                                        <SwiperSlide key={blog.id ?? index} className="item" onClick={() => navigate('/blog-detail', { state: { blogId: blog.id } })}>
                                            <BlogCard blog={blog} />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/* <button type="button" className="carouselNav carouselNav-prev" ref={prevRef} aria-label="Previous">&#8249;</button>
                                <button type="button" className="carouselNav carouselNav-next" ref={nextRef} aria-label="Next">&#8250;</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default OurLatestBlog
